<template>
  <v-dialog
    ref="dialogRange"
    v-model="modal"
    :return-value.sync="range"
    persistent
    width="290px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        v-model="dateRangeText"      
        label="Period"                
        prepend-icon="mdi-calendar"
        readonly
        v-bind="attrs"
        v-on="on"
      />
    </template>
    <v-date-picker
      v-model="range"
      scrollable
      :first-day-of-week="1"                    
      locale="sv-se"
      range
      :rules="dateRules"
    >
      <v-spacer />
      <v-btn
        text
        color="primary"
        @click="modal = false"
      >
        Cancel
      </v-btn>
      <v-btn
        text
        color="primary"
        @click="setRange()"
      >
        OK
      </v-btn>
    </v-date-picker>
  </v-dialog>
</template>
<script>
import moment from 'moment'
export default {
  name:'RangePicker',
  props:{    
    'dateRange':{
      type:Array,
      required: true
    }
  },
  data(){
    return{
        modal:false,
        range:this.dateRange,
        dateRules: [v => !!v ||'Måste ha ett värde',
            v => moment(v[0]).isBefore(moment(v[1])) || 'Felaktig period    ']
    }
  },
  computed:{
    dateRangeText() {
      return this.range.join(' - ')
    },       
  },
  methods:{
    setRange(){        
        this.$refs.dialogRange.save(this.range)
        this.$emit('selected',this.range)
        this.modal= false
    },   
  }
}
</script>